import { Box, Button, Stack, Typography } from "@mui/material";
import MarketingGeniusButton from "../EmpowerYourCareer/MarketingGeniusButton";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
const featuredCardsData = [
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/locationIconReviewsSectionWhite.svg",
    text: "Seattle, WA",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/moneyIconWhite.svg",
    text: "80,000 - 100,000 per year",
  },
];

function FeaturedJobCard({ shadow = false }) {
  const { darkMode } = useDarkMode();
  return (
    <Stack
      id="software-developer"
      direction="row"
      sx={{
        bgcolor: darkMode ? "#262626" : "#FFFFFF",
        py: "20px",
        pt: "24px",
        px: "30px",
        borderRadius: "20px",
        boxShadow: "5px 10px 30px 0px #0000000D",
        border: "1px solid #E3E3E3",
        alignItems: "start",
        // gap: "40px",
        // minWidth: "610px",
        // maxWidth: "671px",
        minWidth: "530px",
        maxWidth: "671px",
        justifyContent: "space-between",
        // boxShadow: shadow
        //   ? `${
        //       darkMode
        //         ? "20px 20px 0px #333333"
        //         : "20px 20px 0px rgba(0, 0, 0, 0.2)"
        //     }`
        //   : "none",
      }}
    >
      <Stack>
        {" "}
        <Stack direction="row" sx={{ alignItems: "center", gap: "18px" }}>
          {" "}
          <Box
            component="img"
            src="/images/acme.jpg"
            sx={{
              width: "90px",
              height: "90px",
              objectFit: "cover",
              borderRadius: "10px",
              display: "block",
            }}
          ></Box>
          <Box>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "700",
                fontSize: "18px",
                lineHeight: "26px",
                fontFamily: "Inter",
                color: darkMode ? "#ffffff" : "#0E0B33",
              }}
            >
              UXLabs Company
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "22px",
                fontFamily: "Inter",
                color: darkMode ? "#929292" : "#878599",
              }}
            >
              Feb 18, 2023
            </Typography>
            {featuredCardsData.map((data) => (
              <>
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    gap: "6px",
                    pt: "0px",
                    justifyContent: "start",
                  }}
                >
                  <Box
                    component="img"
                    src={darkMode ? data.iconSrcDarkMode : data.iconSrc}
                    sx={{ width: "15px", height: "15px" }}
                  ></Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "24px",
                      fontFamily: "Inter",
                      color: darkMode ? "#c9c9c9" : "#0E0B33",
                      textAlign: "center",
                    }}
                  >
                    {data.text}
                  </Typography>
                </Stack>
              </>
            ))}
          </Box>
        </Stack>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "700",
            fontSize: "26px",
            lineHeight: "26px",
            fontFamily: "Inter",
            color: darkMode ? "#ffffff" : "#0E0B33",
            pt: "30px",
            pb: "8px",
          }}
        >
          Software Developer
        </Typography>
        <MarketingGeniusButton
          featuredCardButtonDarkmodeBg="#f5f5f5"
          featuredCardButtonDarkmodeColor="#ffffff"
          alignSelf="start"
          borderRadius="38px"
          bgColor="#f5f5f5"
          px="24px"
          py="8px"
        >
          Full Time
        </MarketingGeniusButton>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "Inter",
            color: darkMode ? "#929292" : "#878599",
            maxWidth: "340px",
            py: "13px",
          }}
        >
          Develop and maintain software applications and programs for our
          clients using various programming languages and platforms.
        </Typography>
      </Stack>
      <Stack
        sx={{
          px: "24px",
          pt: "10px",
          pb: "22px",
          border: "1px solid #E3E3E3",
          borderRadius: "31px",
          alignItems: "center",
          bgcolor: "#f8f8f8",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "Inter",
            color: darkMode ? "#ffffff" : "#0E0B33",
            maxWidth: "340px",
            py: "12px",
            pb: "24px",
          }}
        >
          Job Closed in
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "700",
            fontSize: "70px",
            lineHeight: "90px",
            fontFamily: "Inter",
            color: darkMode ? "#ffffff" : "#000000",
            maxWidth: "340px",
            pt: "10px",
          }}
        >
          25
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "Inter",
            color: darkMode ? "#929292" : "#878599",
            maxWidth: "340px",
            pb: "28px",
          }}
        >
          D A Y S
        </Typography>
        <Button
          variant="contained"
          sx={{
            borderRadius: "38px",
            px: "26px",
            minWidth: "auto",
            width: "auto",
            textTransform: "none",
            bgcolor: "#000000",
            color: "#FFFFFF",
            boxShadow: "none",
            py: "18px",
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "Inter",
            fontWeight: "700",
          }}
        >
          Apply Now
        </Button>
      </Stack>
    </Stack>
  );
}

export default FeaturedJobCard;
